import React from 'react';
import styled from "styled-components/macro";

export default function StripeStatus({ status }) {
  return <Detail className={status}>{status}</Detail>;
}

const Detail = styled.dd`
    text-transform: capitalize;

    &.active {
        font-weight: bold;
        color: #21B67F;
    }

    &.past_due {
        font-weight: bold;
        color: #EF6075;
    }
`;
